var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.995,
    height: 27,
    viewBox: "0 0 26.995 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M209.492-189.505m0,0A7.4,7.4,0,0,1,209.03-187a4.479,4.479,0,0,1-2.563,2.563,7.431,7.431,0,0,1-2.505.464c-1.424.063-1.851.079-5.454.079s-4.035-.016-5.454-.079a7.4,7.4,0,0,1-2.505-.464A4.156,4.156,0,0,1,189-185.44a4.2,4.2,0,0,1-1.007-1.551,7.428,7.428,0,0,1-.464-2.505c-.064-1.424-.079-1.851-.079-5.454s.016-4.035.079-5.454a7.4,7.4,0,0,1,.464-2.505A4.1,4.1,0,0,1,189-204.46a4.192,4.192,0,0,1,1.551-1.007,7.431,7.431,0,0,1,2.505-.464c1.424-.063,1.851-.079,5.454-.079s4.035.016,5.454.079a7.4,7.4,0,0,1,2.505.464,4.151,4.151,0,0,1,1.551,1.007,4.2,4.2,0,0,1,1.008,1.551,7.429,7.429,0,0,1,.464,2.505c.063,1.424.079,1.851.079,5.454s-.016,4.024-.079,5.449Zm2.431-11.024a9.866,9.866,0,0,0-.628-3.276,6.587,6.587,0,0,0-1.561-2.395,6.646,6.646,0,0,0-2.389-1.556,9.893,9.893,0,0,0-3.275-.628c-1.445-.069-1.9-.084-5.57-.084s-4.125.016-5.564.079a9.87,9.87,0,0,0-3.275.628,6.589,6.589,0,0,0-2.395,1.561,6.647,6.647,0,0,0-1.556,2.389,9.89,9.89,0,0,0-.628,3.275c-.069,1.445-.085,1.9-.085,5.57s.016,4.125.079,5.565a9.865,9.865,0,0,0,.628,3.276,6.659,6.659,0,0,0,1.561,2.395,6.645,6.645,0,0,0,2.389,1.556,9.893,9.893,0,0,0,3.276.628c1.44.063,1.9.079,5.565.079s4.125-.016,5.565-.079a9.863,9.863,0,0,0,3.275-.628,6.906,6.906,0,0,0,3.951-3.95,9.9,9.9,0,0,0,.628-3.276c.063-1.44.079-1.9.079-5.565s-.005-4.125-.069-5.565Z",
    transform: "translate(-185 208.463)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M199.355-189.552m0,0a4.553,4.553,0,0,1-4.553-4.553,4.553,4.553,0,0,1,4.553-4.553,4.553,4.553,0,0,1,4.553,4.553A4.553,4.553,0,0,1,199.359-189.551Zm0-11.571a7.02,7.02,0,0,0-7.018,7.018,7.02,7.02,0,0,0,7.018,7.018,7.02,7.02,0,0,0,7.019-7.018A7.02,7.02,0,0,0,199.359-201.122Z",
    transform: "translate(-192.341 201.122)",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M209.626-201.6m0,0a1.639,1.639,0,0,1-1.639,1.638,1.639,1.639,0,0,1-1.638-1.638,1.638,1.638,0,0,1,1.638-1.639A1.639,1.639,0,0,1,209.622-201.6Z",
    transform: "translate(-206.345 203.239)",
    fill: "#fff",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-instagram",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-instagram-2",
    "data-name": "icon-instagram",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M184-209.463h28.784v28.789H184Z",
    transform: "translate(-184.895 208.569)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(6.479 6.484)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M191.341-202.122h15.847v15.847H191.341Z",
    transform: "translate(-192.246 201.217)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(19.905 4.666)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M205.345-204.239h5.092v5.087h-5.092Z",
    transform: "translate(-206.25 203.334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.9c721f9b7da2947352759020623a6221.svg";
export { ForwardRef as ReactComponent };